import React from 'react';
import {
  AttentionIcon,
  CheckmarkIcon,
} from '../../../assets/svg/SVGComponents';
import {
  IStatusInfo,
  slotStatus,
  tournamentStatus,
} from '../../../utils/tournament/status';
import { LiveDot, Pill } from './styles';

interface IStatusPillProps {
  status?: string | null;
  /** Status do torneio ou de uma rodada do cronograma. */
  scope?: 'tournament' | 'slot';
  /** Rodada de equipe desclassificada: mostra isso no lugar do status. */
  disqualified?: boolean;
  size?: 'sm' | 'md';
}

const ToneIcon: React.FC<{ info: IStatusInfo }> = ({ info }) => {
  if (info.tone === 'live') return <LiveDot aria-hidden />;
  if (info.tone === 'done')
    return (
      <CheckmarkIcon
        aria-hidden
        stroke="currentColor"
        strokeWidth={2}
        fill="none"
      />
    );
  if (info.tone === 'alert')
    return (
      <AttentionIcon
        aria-hidden
        stroke="currentColor"
        strokeWidth={2}
        fill="none"
      />
    );
  return null;
};

/** Status legível com cor e ícone. Status desconhecido não renderiza nada. */
const StatusPill: React.FC<IStatusPillProps> = ({
  status,
  scope = 'tournament',
  disqualified = false,
  size = 'sm',
}) => {
  const info =
    scope === 'slot'
      ? slotStatus(status, disqualified)
      : tournamentStatus(status);

  if (!info) return null;

  return (
    <Pill $tone={info.tone} $size={size}>
      <ToneIcon info={info} />
      {info.label}
    </Pill>
  );
};

export default StatusPill;
